import {Api} from '../api/api';

class ApiContent {
    /**
     * @param {string} endpoint
     * @param {Object} requestParams
     * @param {CallableFunction} loadedCallback
     */
    constructor(endpoint, requestParams, loadedCallback) {
        Api.post(endpoint, requestParams, (response) => {
            if (response.isFailure()) {
                loadedCallback({content: '', count: 0});
            }

            let list = response.get('list', []);

            loadedCallback({
                content: this.renderContent(typeof list === 'object' ? Object.values(list) : list),
                count: response.get('count', 0)
            });
        });
    }

    /** @param {Array} results */
    renderContent(results) {
        let rendered = '';
        Array.from(results).forEach((result) => rendered += this.formatResultTemplate(result));

        return rendered;
    }

    formatResultTemplate(result) {
        return result;
    }
}

export {ApiContent};
